import i18n from "@/commonui/locales/i18n";
import { CommonLocale } from "@/locales/localeid";
import { flagIcons } from "@/style/flags";
import { AuthService, fmtMsg, GLGlobal, LanguageCodes, LanguageLocale, OidcLogin, RoleName } from "commonui";
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { SubmenuItem } from "..";
import VcHeaderMenuItem from "../header-menu-item/header-menu-item.vue";

@Component({
	components: {
		VcHeaderMenuItem
	}
})
export default class VcHeaderMenu extends Vue {
	public oidcModule = getModule(OidcLogin);
	public languageMenus = Object.getOwnPropertyNames(LanguageCodes)
		.filter((prop) => typeof LanguageCodes[prop] === "number")
		.map<SubmenuItem>((language) => {
			return {
				text: LanguageLocale[language],
				clickEvent: "languageChanges",
				iconSVG: flagIcons[language],
				_data: language
			};
		});

	public userMenus: SubmenuItem[] = [
		{
			text: "Edit Profile",
			url: `${GLGlobal.authorityUrl()}/Account/Profile`,
			isExternalUrl: true
		},
		{
			text: "Log Out",
			clickEvent: "logout"
		}
	];
	public role: string = "";

	created() {}

	get userName() {
		return this.oidcModule.loginInfo?.profile.name;
	}

	@Watch("oidcModule.loginInfo.profile")
	private setRole(): void {
		const rolesInHigherOrder = {
			SystemAdmin: 1,
			GlobalHead: 2,
			ContentAdmin: 3,
			TrainingAdmin: 4,
			RegionAdmin: 5,
			AccountManager: 6,
			TrainingManager: 7,
			Trainer: 8,
			SchoolAdmin: 9,
			CampusAdmin: 10,
			Teacher: 11,
			Parent: 12
		};

		const localeRoleKeys = {
			[RoleName.systemAdmin]: CommonLocale.CommonRoleSystemAdmin,
			[RoleName.globalHead]: CommonLocale.CommonRoleGlobalHead,
			[RoleName.contentAdmin]: CommonLocale.CommonRoleContentAdmin,
			[RoleName.trainingAdmin]: CommonLocale.CommonRoleTrainingAdmin,
			[RoleName.regionAdmin]: CommonLocale.CommonRoleRegionAdmin,
			[RoleName.accountManager]: CommonLocale.CommonRoleAccountManager,
			[RoleName.trainingManager]: CommonLocale.CommonRoleTrainingManager,
			[RoleName.trainer]: CommonLocale.CommonRoleTrainer,
			[RoleName.schoolAdmin]: CommonLocale.CommonRoleSchoolAdmin,
			[RoleName.campusAdmin]: CommonLocale.CommonRoleCampusAdmin,
			[RoleName.teacher]: CommonLocale.CommonRoleTeacher,
			[RoleName.parent]: CommonLocale.CommonRoleParent
		};

		const userRoles = this.oidcModule.loginInfo?.profile.roles;
		const userRoleAsHigherOrder = userRoles?.sort(
			(roleA, roleB) => rolesInHigherOrder[roleA] - rolesInHigherOrder[roleB]
		);
		const role = userRoleAsHigherOrder![0];
		this.role = fmtMsg(localeRoleKeys![role]);
	}

	get isSignedIn() {
		return this.oidcModule.loginInfo?.loggedin;
	}

	get helpUrl(): string {
		return process.env.VUE_APP_AUTHORITY_URL + "/account/help";
	}

	get currentLanguage(): string {
		return LanguageLocale[this.$i18n?.locale];
	}

	get userAvatarUrl() {
		return this.oidcModule.loginInfo?.profile.avatarUrl;
	}

	signIn() {
		AuthService.storePagethenSigninRedirect();
	}

	signOut() {
		AuthService.storePagethenSignoutRedirect();
	}

	languageChanged({ _data }) {
		console.log(_data, "_data");
		i18n.locale = _data;
	}
}
